export const projects = [
	{
		title: "aTrace",
		tools: "React + Next.js + TypeScript + Node.js + MongoDB",
		description:
			"Logistics visibility platform powering real-time shipment tracking and operational insights for supply chain systems.",
		live_link: "https://atrace.co/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Ailomix",
		tools: "Next.js + TypeScript + Node.js + Trigger.dev + AWS S3",
		description:
			"AI-powered media generation platform for creating voiceovers, images, and motion videos at scale.",
		live_link: "https://ailomix.com/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Trivoh",
		tools: "React + TypeScript + Node.js + WebRTC + Socket.io",
		description:
			"Real-time video conferencing and collaboration platform with breakout rooms, chat, and screen sharing.",
		live_link: "http://trivoh.com/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Maotronics",
		tools: "Next.js + TypeScript + Node.js + IoT + MongoDB",
		description:
			"Integrated hardware-software solutions across Agritech, Off-Grid Systems, AI, and IoT verticals.",
		live_link: "http://maotronics.cc/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Perxels",
		tools: "Next.js + TypeScript + Stripe + Cloudinary + MongoDB",
		description:
			"Creative design school platform with course enrollment, portfolio showcases, and integrated payments.",
		live_link: "https://www.perxels.com/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Checkedgar",
		tools: "Next.js + Node.js + MongoDB + Chakra UI v2",
		description:
			"Personal platform showcasing Edgar's podcasts, shows, movies, stories, and events.",
		live_link: "https://checkedgar.com/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Gupbook Socials",
		tools: "Next.js 15 + TypeScript + TailwindCSS + Postgres + Firebase",
		description:
			"Full-featured social media app with posts, follows, likes, comments, and notifications — similar to X.",
		live_link: "https://nextjs-15-social-media-app.vercel.app/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "The Eniivy Brand",
		tools: "Next.js + TypeScript + Firebase + Cloudinary",
		description:
			"Portfolio platform for Eniivy featuring gallery, event postings and job listings with an integrated CMS.",
		live_link: "https://eniivy.com/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Sabi Consulting",
		tools: "React + TailwindCSS + Node.js + MongoDB",
		description:
			"Official site for a tech school offering course enrollment and training resources.",
		live_link: "https://www.sabiconsulting.org/",
		github_link: "",
		isDisabled: true,
	},
	{
		title: "Emniks Engineering",
		tools: "React + TailwindCSS",
		description:
			"Engineering portfolio website showcasing Emniks' projects and services.",
		live_link: "https://emniksengineering.com/",
		github_link: "",
		isDisabled: false,
	},
	{
		title: "Ophir",
		tools: "React + TailwindCSS + Ant Design + Node.js + MongoDB + Paystack",
		description:
			"E-learning platform built for Web3 students with integrated payment support.",
		live_link: "https://ophir.netlify.app/",
		github_link: "",
		isDisabled: false,
	},
	{
		title: "YC Directory",
		tools: "Next.js + TypeScript + Supabase + TailwindCSS",
		description:
			"Platform to pitch startup ideas, gain votes, and grow online visibility.",
		live_link: "https://yc-directory-sand-two.vercel.app/",
		github_link: "",
		isDisabled: false,
	},
];
